import { render } from "./SideMenuArea.vue?vue&type=template&id=082457f2&scoped=true"
import script from "./SideMenuArea.vue?vue&type=script&lang=js"
export * from "./SideMenuArea.vue?vue&type=script&lang=js"

import "./SideMenuArea.vue?vue&type=style&index=0&id=082457f2&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\kmrtt\\20240208サイトデータ修正\\k_5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082457f2"]])

export default __exports__